export enum GameSDKLanguage {
  enUS = 'en-US',
  esES = 'es_ES',
  deDE = 'de_DE',
  ptBR = 'pt_BR',
  arAR = 'ar-AR',
  frFR = 'fr_FR',
  idID = 'id-ID',
  itIT = 'it-IT',
  jaJP = 'ja-JP',
  koKR = 'ko_KR',
  nlNL = 'nl_NL',
  plPL = 'pl_PL',
  ruRU = 'ru_RU',
  thTH = 'th-TH',
  trTR = 'tr_TR',
  viVN = 'vi-VN',
  zhCN = 'zh-CN',
  zhTW = 'zh-TW',
}

// @新语言
export enum Language {
  English = 'en-US',
  // Chinese = 'zh-CN',
  Spanish = 'es',
  Japanese = 'ja',
  Korea = 'ko',
  ZhHant = 'zh-Hant',
  Ru = 'ru',
  De = 'de',
  Fr = 'fr',
  Pt = 'pt',
}

export const languageToGameSdk: Record<Language, GameSDKLanguage> = {
  [Language.English]: GameSDKLanguage.enUS,
  // [Language.Chinese]: GameSDKLanguage.zhCN,
  [Language.Spanish]: GameSDKLanguage.esES,
  [Language.Japanese]: GameSDKLanguage.jaJP,
  [Language.Korea]: GameSDKLanguage.koKR,
  [Language.ZhHant]: GameSDKLanguage.zhTW,
  [Language.Ru]: GameSDKLanguage.ruRU,
  [Language.De]: GameSDKLanguage.deDE,
  [Language.Fr]: GameSDKLanguage.frFR,
  [Language.Pt]: GameSDKLanguage.ptBR,
};
